import _ from "lodash";
import { Types } from "../actions/schemeActions";



const schemeReducers = (state, action) => {
  switch (action.type) {

    case Types.SCHEME_OPEN_MODAL: {

      let newState = _.cloneDeep(state);

      newState.pensions.scheme.modalState = action.status;
      newState.pensions.scheme.modalScheme = action.scheme;

      return newState;
    }

    case Types.SCHEME_SAVING: {
      let newState = _.cloneDeep(state)

      newState.pensions.scheme.modalSaving = action.id ? true : false

      return newState
    }

    case Types.SCHEME_SAVE_CURRENT: {
      let newState = _.cloneDeep(state)

      newState.pensions.scheme.modalSaving = false
      newState.pensions.scheme.modalState = false

      return newState
    }

    case Types.SCHEME_DELETE_MODAL: {

      let newState = _.cloneDeep(state);

      newState.pensions.scheme = {
        ...newState.pensions.scheme, deleteSchemeModal: {
          show: action.status,
          scheme: action.scheme,
        }
      };

      return newState;
    }

    case Types.SCHEME_DELETING: {

      let newState = _.cloneDeep(state);

      newState.pensions.scheme = {
        ...newState.pensions.scheme, deleteSchemeModal: {
          deleting: true
        }
      };

      return newState;
    }

    case Types.SCHEME_DELETED: {

      let newState = _.cloneDeep(state);

      newState.pensions.scheme = {
        ...newState.pensions.scheme,
        deleteSchemeModal: {
          deleting: false,
        },
      };

      return newState;
    }

    // case Types.SCHEME_CONFIRM_CHANGE_MODAL: {

    //   let newState = _.cloneDeep(state);

    //   newState.pensions.scheme = {
    //     ...newState.pensions.scheme, confirmModal: {
    //       input: action.input,
    //       status: action.status,
    //       type: action.formType,
    //     }
    //   };

    //   return newState;
    // }

    case Types.SCHEME_UPDATING: {
      let newState = _.cloneDeep(state)

      newState.pensions.scheme.schemeUpdating = true

      return newState
    }

    case Types.SCHEME_UPDATE: {

      let newState = _.cloneDeep(state);

      newState.pensions.scheme.list = action.data;
      newState.pensions.scheme.schemeUpdating = false

      return newState;
    }

    default:
      return state;
  }
};

export default schemeReducers;